import { Injectable } from '@angular/core';
import { catchError, map, take } from 'rxjs/operators';
import {
  HttpClient,
  HttpHeaders,
  HttpParams
} from '@angular/common/http';
import { ConnectionDetailsResultModel, PharmacyData,PharmacyGridDataMapper } from '../features/DTO/pharmacy';
import { PharmacySearchModel } from '../features/DTO/pharmacy-search';
import { PharmacyCRUDModel, PharmacyCRUDResultModel,PharmacyLookupDataMapper } from '../features/DTO/pharmacy-crud';
import { FuncsService } from '../services/funcs.service';
import { PharmacyStoreModel,PharmacyStoreResultModel } from '../features/DTO/pharmacy-store-crud';
import { PharmacyStoreSearchRequestModel, PharmacyStoreSearchResponseModel, PharmacyStoreSearchGridDataMapper } from '../features/DTO/pharmacy-store-search';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs';
import { ConnectionDetails } from '../features/DTO/pharmacy';
import { PharmacyStoreSyncSearchRequestModel, PharmacyStoreSyncSearchResponseModel, PharmacyStoreSyncSearchGridDataMapper } from '../features/DTO/pharmacy-store-sync-search';
@Injectable({
    providedIn: 'root'
  })

  export class PharmacyService {
    private pharmacyGridDataMapper = new PharmacyGridDataMapper();
    private pharmacyLookupDataMapper = new PharmacyLookupDataMapper();
    private pharmacyStoreSearchGridDataMapper = new PharmacyStoreSearchGridDataMapper();
    private pharmacyStoreSyncSearchGridDataMapper = new PharmacyStoreSyncSearchGridDataMapper();
    constructor(private http: HttpClient, private globalFunc:FuncsService) { 

    }
    getPharmacyGrid(pharmacySearchModel:PharmacySearchModel) {
      let data:any=JSON.stringify(pharmacySearchModel);
      return this.http.post<Array<PharmacyData>>(environment.pharmacyListUrl,data)
      .pipe(take(1), map((data: any) => this.pharmacyGridDataMapper.mapToModel(data)))
      .pipe(catchError(this.globalFunc.error));
    }

    getPharmacyDetails(pharmacyModel:PharmacyCRUDModel) {
      let data:any=JSON.stringify(pharmacyModel);
      return this.http.post<PharmacyCRUDModel>(environment.pharmacyLookupUrl,data)
      .pipe(take(1), map((data: any) => this.pharmacyLookupDataMapper.mapToModel(data)))
      .pipe(catchError(this.globalFunc.error));
    }

    savePharmacy(pharmacyModel:PharmacyCRUDModel) {
      let data:any=JSON.stringify(pharmacyModel);
      return this.http.post<PharmacyCRUDResultModel>(environment.pharmacyCrudUrl,data)
      .pipe(catchError(this.globalFunc.error));
    }

    testConnection(pharmacyModel:ConnectionDetails) {
      let data:any=JSON.stringify(pharmacyModel);
      console.log(environment);
      console.log(environment.testConnectivityUrl);
      console.log(environment.pharmacyListUrl);
      return this.http.post<ConnectionDetailsResultModel>(environment.testConnectivityUrl,data)
      .pipe(catchError(this.globalFunc.error));
    }

    updatePharmacy(pharmacyModel:PharmacyCRUDModel) {
      let data:any=JSON.stringify(pharmacyModel);
      return this.http.put<PharmacyCRUDResultModel>(environment.pharmacyCrudUrl,data)
      .pipe(catchError(this.globalFunc.error));
    }

    savePharmacyStores(pharmacyModel:PharmacyStoreModel) {
      let data:any=JSON.stringify(pharmacyModel);
      return this.http.post<PharmacyStoreResultModel>(environment.pharmacyStoresCrudUrl,data)
      .pipe(catchError(this.globalFunc.error));
    }

    deletePharmacyStore(pharmacyModel:PharmacyStoreModel) {
      let data:any=JSON.stringify(pharmacyModel);
      const httpOptions = {
        body: data
      };
        return this.http.delete<PharmacyStoreResultModel>(environment.pharmacyStoresCrudUrl,httpOptions)
        .pipe(catchError(this.globalFunc.error));
    }

    getActivePharmacyChains(
      searchTerm: string | null = null,
      pageNumber: number | null = null,
      pageSize: number | null = null
    ): Observable<any> {
      let params = new HttpParams().set('IsEnabled', '1');

      if (searchTerm) {
        params = params.set('PharmacyName', searchTerm);
      }
      if (pageNumber !== null) {
        params = params.set('PageNumber', pageNumber.toString());
      }
      if (pageSize !== null) {
        params = params.set('PageSize', pageSize.toString());
      }

      return this.http.get(environment.pharmacyListUrl, { params });
    }

    getPharmacyStoreSearchGrid(pharmacyStoreSearchRequestModel: PharmacyStoreSearchRequestModel) {
      let params = new HttpParams()
        .set('PageNumber', pharmacyStoreSearchRequestModel.PageNumber.toString())
        .set('PageSize', pharmacyStoreSearchRequestModel.PageSize.toString());

      if (pharmacyStoreSearchRequestModel.PharmacyId) {
        params = params.set("PharmacyId", pharmacyStoreSearchRequestModel.PharmacyId.toString());
      }

      if (pharmacyStoreSearchRequestModel.NCPDPID) {
        params = params.set("NCPDPID", pharmacyStoreSearchRequestModel.NCPDPID.toString());
      }

      return this.http.get(environment.pharmacyStoresCrudUrl, { params })
        .pipe(take(1), map((data: any) => this.pharmacyStoreSearchGridDataMapper.mapToModel(data)))
        .pipe(catchError(this.globalFunc.error));
    }
    
    getPharmacyStoreSyncSearchGrid(pharmacyStoreSyncSearchRequestModel:PharmacyStoreSyncSearchRequestModel){
      let data:any=JSON.stringify(pharmacyStoreSyncSearchRequestModel);
      return this.http.post<PharmacyStoreSyncSearchResponseModel>(environment.configUIAPIUrl+"/searchpharmacystoresync",data)
      .pipe(take(1), map((data: any) => this.pharmacyStoreSyncSearchGridDataMapper.mapToModel(data)))
      .pipe(catchError(this.globalFunc.error));
    }
  }
  